import React from 'react'
import Footer from '../LandingPage/Footer'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
const AboutUs = () => {
    const contact = {
        head: " Welcome to My Portfolio",
        para: "I have decided to chase your goals!",
      };
  return (
    <div>
      <Header />
      <Navbar />
     <AboutPostHeader obj={contact} />

      <div className="container mt-5">

        <div className="row mt-5">
          <div className="col-md-4">
            <img src="https://images.squarespace-cdn.com/content/v1/583ed05c59cc68a8c3e45c0f/1482074282081-KQBCRLEWPLWTJKWBCR4X/vision.png?format=750w" className='about-img disp-image' />{' '}
          </div>
          <div className="col-md-8">
            <h2 className='text-primary font-weight-bold'>My VISION</h2>
            <p className='text-justify'>
              Being one of the most trusted global IT solution provider my vision is to work in a dynamic professional environment with a growing organization and utilize my creativity and innovative thinking for benefit of the organization and myself.
            </p>
   <a href='https://www.facebook.com/muhammadhassan.naseer.79/about'><button className='btn btn-outline-success'>About Me</button></a> 
        
          </div>
        </div>
        <div className="row mt-5">
        <div className="col-md-8">
            <h2  className='text-primary font-weight-bold'>My MISSION</h2>
            <p className='text-justify'>
              Being one of the most trusted global IT solution provider and
              to deliver the most innovative technical solutions to my customers and to make their work more productive. I accomplish this mission through the use of industry-proven technologies, a well-established development process, solid expertise and a sincere desire to build long-term relationships with my customers.
            </p>
  <a href='https://www.facebook.com/muhammadhassan.naseer.79/about'> <button className='btn btn-outline-success'>About Me</button></a> 
          </div>
          <div className="col-md-4 text-right">
            <img src='https://fabrikbrands.com/wp-content/uploads/Company-Mission-Statement-1.jpg' className='about-img disp-image'/>{' '}
          </div>
       
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default AboutUs
